<div class="confirm-action-dialog">

  <div class="dialog-body">
    <h1 mat-dialog-title class="text-center">{{ title }}</h1>
    <p>{{ textToDisplay }}</p>

    @if (items && items.length) {
      <mat-list dense class="scrollable-dialog-list">
        @for (item of items; track item) {
          <mat-list-item>{{ item.name }}</mat-list-item>
        }
      </mat-list>
    }
  </div>

  @if (buttonsInfo) {
    <div class="dialog-footer">
      <mat-dialog-actions class="two-button-full-width-flex">
        @if (buttonsInfo.denyText) {
          <button mat-stroked-button mat-dialog-close (click)="unconfirmDelete()">{{ buttonsInfo.denyText }}</button>
        }
        @if (buttonsInfo.confirmText) {
          <button mat-raised-button class="edu-custom-btn" color="{{ buttonsInfo.confirmBtnColor }}" (click)="confirmDelete()">{{ buttonsInfo.confirmText }}</button>
        }
      </mat-dialog-actions>
    </div>
  }

</div>